export const jetCatalogItems = [
  {
    id: 1,
    category: 'Light Jet',
    name: 'Cessna Citation I',
    image: '/img/jet-catalog/jet1-img.webp',
    tail: 'N16NL',
    passengers: '6',
    price: '$5 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 2,
    category: 'Mid-Size Jet',
    name: 'Bombardier Lear 60',
    image: '/img/jet-catalog/jet2-img.webp',
    tail: 'N357WP',
    passengers: '8',
    price: '$7 500',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 3,
    category: 'Mid-Size Jet',
    name: 'Bombardier Lear 60',
    image: '/img/jet-catalog/jet3-img.webp',
    tail: 'N470MD',
    passengers: '8',
    price: '$7 500',
    pdf: '/img/jet-catalog/example.pdf',
  },
  // {
  //   id: 4,
  //   category: 'Mid-Size Jet',
  //   name: 'Bombardier Lear 60',
  //   image: '/img/jet-catalog/jet4-img.webp',
  //   tail: 'N743LG',
  //   passengers: '7',
  //   price: '$7 500',
  //   pdf: '/img/jet-catalog/example.pdf',
  // },
  {
    id: 5,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet5-img.webp',
    tail: 'N110CX',
    passengers: '8+1',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 6,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet18-img.webp',
    tail: 'N60ES',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },

  {
    id: 7,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet7-img.webp',
    tail: 'N119RM',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 8,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet8-img.webp',
    tail: 'N348CF',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 9,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet9-img.webp',
    tail: 'N976JS',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 19,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet22-img.webp',
    tail: 'N956JS',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 20,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet22-img.webp',
    tail: 'N928JS',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  // {
  //   id: 21,
  //   category: 'Super Mid-Size Jet',
  //   name: 'Cessna Citation X',
  //   image: '/img/jet-catalog/jet22-img.webp',
  //   tail: 'N474ME',
  //   passengers: '8+1',
  //   price: '$9 000',
  //   pdf: '/img/jet-catalog/example.pdf',
  // },
  {
    id: 22,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet22-img.webp',
    tail: 'N612EM',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  // {
  //   id: 10,
  //   category: 'Super Mid-Size Jet',
  //   name: 'Bombardier Challenger 601',
  //   image: '/img/jet-catalog/jet10-img.webp',
  //   tail: 'N855MM',
  //   passengers: '10',
  //   price: '$9 000',
  //   pdf: '/img/jet-catalog/example.pdf',
  // },
  // {
  //   id: 11,
  //   category: 'Super Mid-Size Jet',
  //   name: 'Bombardier Challenger 601',
  //   image: '/img/jet-catalog/jet11-img.webp',
  //   tail: 'N329MD',
  //   passengers: '10',
  //   price: '$9 000',
  //   pdf: '/img/jet-catalog/example.pdf',
  // },
  // {
  //   id: 12,
  //   category: 'Super Mid-Size Jet',
  //   name: 'Bombardier Challenger 300',
  //   image: '/img/jet-catalog/jet12-img.webp',
  //   tail: 'N950BA',
  //   passengers: '9',
  //   price: '$9 000',
  //   pdf: '/img/jet-catalog/example.pdf',
  // },
  {
    id: 13,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV',
    image: '/img/jet-catalog/jet13-img.webp',
    tail: 'N880CF',
    passengers: '11',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
  {
    id: 14,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV-SP',
    image: '/img/jet-catalog/jet17-img.webp',
    tail: 'N707VV',
    passengers: '15',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
  {
    id: 15,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV',
    image: '/img/jet-catalog/jet15-img.webp',
    tail: 'N808CF',
    passengers: '13',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
  {
    id: 16,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV',
    image: '/img/jet-catalog/jet19-img.webp',
    tail: 'N18TV',
    passengers: '13',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
  {
    id: 17,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV',
    image: '/img/jet-catalog/jet20-img.webp',
    tail: 'N93QQ',
    passengers: '13+1',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
  // {
  //   id: 18,
  //   category: 'Heavy Jet',
  //   name: 'Gulfstream GIV',
  //   image: '/img/jet-catalog/jet21-img.webp',
  //   tail: 'N406JS',
  //   passengers: '12',
  //   price: '$11 775',
  //   pdf: '/img/jet-catalog/example.pdf',
  //   mostPopular: true,
  // },
  {
    id: 23,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV',
    image: '/img/jet-catalog/jet23-img.webp',
    tail: 'N996GA',
    passengers: '14+1',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
  {
    id: 24,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet22-img.webp',
    tail: 'N610WU',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 25,
    category: 'Super Mid-Size Jet',
    name: 'Cessna Citation X',
    image: '/img/jet-catalog/jet4-img.webp',
    tail: 'N702FL',
    passengers: '8',
    price: '$9 000',
    pdf: '/img/jet-catalog/example.pdf',
  },
  {
    id: 26,
    category: 'Heavy Jet',
    name: 'Gulfstream GIV-SP',
    image: '/img/jet-catalog/jet10-img.webp',
    tail: 'N102JE',
    passengers: '14',
    price: '$11 775',
    pdf: '/img/jet-catalog/example.pdf',
    mostPopular: true,
  },
];
